import {COLLECTION_TYPES} from '@goproblems/shared/contracts/collections';

export {COLLECTION_TYPES};

// Keep the original Add to palette, with a stable color for each category.
export const COLLECTION_TYPE_COLORS = {
    Style: '#049e1c',
    Collection: '#a62004',
    Sequence: '#3357FF',
    Tesuji: '#fd058e',
    Joseki: '#A133FF',
} satisfies Record<(typeof COLLECTION_TYPES)[number], string>;

export const getCollectionTypeColor = (group: string): string => {
    const color =
        COLLECTION_TYPE_COLORS[group as keyof typeof COLLECTION_TYPE_COLORS];
    return typeof color === 'string' ? color : '#737373';
};
